
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#400F3F","rx":"8.258"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#FF4702","d":"M33.193 37.07c-.614.35-1.484.35-2.098 0l-10.49-5.97a2.195 2.195 0 00-2.082 0c-.87.5-.87 1.462 0 1.962l11.531 6.569c1.229.7 2.952.7 4.197 0l11.531-6.57c.87-.499.87-1.46 0-1.96l-.017-.013a2.195 2.195 0 00-2.081 0l-10.49 5.983zm0 6.17c-.614.35-1.484.35-2.098 0l-10.49-5.97a2.195 2.195 0 00-2.082 0c-.87.5-.87 1.462 0 1.961l11.531 6.57c1.229.699 2.952.699 4.197 0l11.531-6.57c.87-.5.87-1.461 0-1.96l-.017-.013a2.195 2.195 0 00-2.081 0l-10.49 5.982zm1.075-9.941l11.531-6.57c.87-.499.87-1.473 0-1.973l-11.531-6.569c-1.228-.7-2.951-.7-4.196 0L18.54 24.77c-.87.5-.87 1.474 0 1.973l11.532 6.57c1.228.699 2.968.699 4.196-.013z"}}),_c('path',{attrs:{"fill":"#661A32","stroke":"#FF4702","stroke-width":"2.065","d":"M33.75 32.406l.007-.004 11.528-6.568c.18-.102.18-.08.003-.18l-11.53-6.57c-.913-.52-2.25-.52-3.175 0l-11.529 6.58c-.179.103-.179.08-.003.181l11.531 6.57c.913.52 2.262.516 3.168-.01z"}})])])])
          )
        }
      }
    